<template>
    <i
        class="fa fa-lg pointer"
        :class="'fa-' + icon"
        @click.prevent="regenerateInvoice"
        :title="uLang('app.regenerate_invoice')"
    >
    </i>
</template>

<script>
import { ConfirmationAlert, SuccessAlert } from '~/Swals'

export default {
    name: 'RegenerateInvoiceButton',

    props: {
        icon: {
            type: String,
            required: false,
            default: 'recycle',
        },
        invoiceId: {
            type: Number,
            required: true,
        },
    },

    methods: {
        regenerateInvoice() {
            new ConfirmationAlert({
                text: this.uLang('app.regenerate_this_invoice_question')
            })
                .show()
                .then(async () => {
                    window.axios.post(route('invoices.buy.regenerate', {
                        invoice: this.invoiceId
                    })).then((data) => {
                        this.$emit('regenerated');

                        new SuccessAlert({
                            text: data.message
                        }).show();
                    });
                })
        }
    }
}
</script>

<style>

</style>